var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPendingIcon = function SvgPendingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83333 1.07529C8.63429 1.05853 8.4329 1.04999 8.22949 1.04999C4.25002 1.05013 1.04304 4.32143 1.04297 8.33319C1.04297 12.345 4.24997 15.6163 8.22949 15.6164C9.80281 15.6164 11.2555 15.1051 12.4371 14.2389L11.6036 12.9888C10.6584 13.698 9.49042 14.1164 8.22949 14.1164C5.09938 14.1163 2.54297 11.5377 2.54297 8.33319C2.54304 5.12873 5.09942 2.55013 8.22949 2.54999C8.43339 2.54999 8.63485 2.56093 8.83333 2.58227V1.07529Z",
    fill: "#979998"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22975 14.8667C11.7847 14.8667 14.6665 11.9416 14.6665 8.33335C14.6665 4.72509 11.7847 1.80002 8.22975 1.80002C4.67481 1.80002 1.79297 4.72509 1.79297 8.33335C1.79297 11.9416 4.67481 14.8667 8.22975 14.8667Z",
    stroke: "#979998",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.33 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22998 8.33333V6",
    stroke: "#979998",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22998 8.33334L11.1032 11.2503",
    stroke: "#979998",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPendingIcon;